/* CustomAll gallery diet: hydrate offscreen media only when it approaches the
 * viewport or becomes the selected gallery target. Native media IDs and slide
 * markup stay intact, so Shrine variant switching keeps its existing contract. */
(function () {
  'use strict';

  var selector = 'img[data-sc-gallery-src]';
  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          hydrate(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '800px 0px' })   // 03/09 mobile LCP: no horizontal pre-hydration of the next slides (the gallery warm-up does that after load + idle)
    : null;

  function hydrate(image) {
    if (!image || !image.dataset.scGallerySrc) return;
    if (image.dataset.scGallerySrcset) {
      image.srcset = image.dataset.scGallerySrcset;
    }
    image.src = image.dataset.scGallerySrc;
    image.removeAttribute('data-sc-gallery-src');
    image.removeAttribute('data-sc-gallery-srcset');
  }

  function hydrateWithin(root) {
    if (!root) return;
    if (root.matches && root.matches(selector)) hydrate(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(hydrate);
  }

  function observeWithin(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(selector).forEach(function (image) {
      if (observer) observer.observe(image);
      else hydrate(image);
    });
  }

  document.addEventListener('pointerdown', function (event) {
    var thumbnail = event.target.closest('.thumbnail[data-target], .thumbnail-list__item[data-target]');
    if (!thumbnail) return;
    var targetId = thumbnail.dataset.target || thumbnail.closest('[data-target]').dataset.target;
    hydrateWithin(document.querySelector('[data-media-id="' + targetId + '"]'));
    hydrateWithin(thumbnail);
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.closest('variant-selects, secondary-variant-select, secondary-variant-select-separate')) return;
    requestAnimationFrame(function () {
      hydrateWithin(document.querySelector('.product__media-item.is-active'));
    });
  }, true);

  // The Oct8 global handler keeps other real-image failures visible. Gallery thumbnails
  // instead retain their neutral box; genuine load still clears the same marker/fades in.
  document.addEventListener('error', function (event) {
    var image = event.target;
    if (image && image.tagName === 'IMG' && image.closest('media-gallery .thumbnail')) {
      image.classList.add('sc-image-skeleton');
    }
  }, true);

  var mutationObserver = new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'attributes') {
        if (record.target.classList.contains('is-active') || record.target.getAttribute('aria-current') === 'true') {
          hydrateWithin(record.target);
        }
        return;
      }
      record.addedNodes.forEach(observeWithin);
    });
  });

  // 03/09 mobile LCP: the intersection-driven hydration (visible thumbnails, near slides) starts
  // only once the gallery's main image has loaded (`sc-media-ready`, set by the gallery script) or
  // the window load fires — on a slow link those ~10 thumbnails used to share the first seconds
  // with the LCP image. Interaction-driven hydration (thumbnail tap, variant change, is-active)
  // stays immediate.
  function startObserving(gallery) {
    if (gallery.__scObserving) return;
    gallery.__scObserving = true;
    observeWithin(gallery);
  }
  function init() {
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      gallery.querySelectorAll('.thumbnail img').forEach(function (image) {
        if (image.complete && !image.naturalWidth) image.classList.add('sc-image-skeleton');
      });
      mutationObserver.observe(gallery, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'aria-current']
      });
      if (gallery.classList.contains('sc-media-ready') || document.readyState === 'complete') {
        startObserving(gallery);
        return;
      }
      var readyWatch = new MutationObserver(function () {
        if (!gallery.classList.contains('sc-media-ready')) return;
        readyWatch.disconnect();
        startObserving(gallery);
      });
      readyWatch.observe(gallery, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('load', function () { readyWatch.disconnect(); startObserving(gallery); }, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
